export class SearchAllSectionResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "SearchAllSectionQuery",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "SearchFilesResponse",
            "format": ""
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "SearchDBResponse",
            "format": ""
        },
        {
            "name": "directoryEntities",
            "baseName": "directoryEntities",
            "type": "SearchDirectoryEntitiesResponse",
            "format": ""
        },
        {
            "name": "hasMore",
            "baseName": "hasMore",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllSectionResult.attributeTypeMap;
    }
    constructor() {
    }
}
